import { SelectedChannel } from './SelectedChannel';
import { THREAD_COMMENT } from 'conversations-message-history/comment-message/constants/messageTypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export function CommentTab({
  currentChannelId,
  onSelectedChange
}) {
  return /*#__PURE__*/_jsx(SelectedChannel, {
    "data-channel-id": THREAD_COMMENT,
    "data-test-id": "INTERNAL-dropdown-trigger",
    "is-selected": `${currentChannelId === THREAD_COMMENT}`,
    onClick: () => onSelectedChange('comment'),
    use: "primary-white",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.capability-editor.channel-label.comment"
    })
  });
}
CommentTab.displayName = 'CommentTab';